<template>
<AdminPanelEGiftsService />
</template>

<script>
import AdminPanelEGiftsService from '../components/AdminPanelEGiftsService.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEGiftsService
    },
    methods: {},
    mounted() {}
}
</script>